import React from 'react';

import { ListCard } from '../../../helpers/list-page/interfaces/list-card.interface';
import { _numTag } from '../../../helpers/list-page/list-page-constants';
import LinkWrapper from '@/components/link-wrapper/link-wrapper';

interface ListViewProps {
  listArray: ListCard[];
}

export const ListView = ({ listArray }: ListViewProps) => {
  const categoryLetters: string[] = [];

  listArray.forEach((listItem) => {
    if (listItem.firstCharIsNum && !categoryLetters.includes(_numTag)) {
      categoryLetters.push(_numTag);
    } else if (!categoryLetters.includes(listItem.firstChar)) {
      categoryLetters.push(listItem.firstChar);
    }
  });

  categoryLetters.sort();
  return (
    <div className="mt-5">
      {categoryLetters.map((categoryLetter, index) => (
        <div
          key={categoryLetter}
          className={`mt-5 flex flex-col rounded-xl bg-background-primary-light p-8 first:mt-0`}
        >
          <div className="font-title text-headingm text-text-default">
            {categoryLetter.toUpperCase()}
          </div>
          {listArray
            .filter((card) => card.firstChar === categoryLetter)
            .sort((a, b) =>
              a.name
                .toLocaleLowerCase()
                .localeCompare(b.name.toLocaleLowerCase()),
            )
            .map((card) => (
              <LinkWrapper
                key={card.id}
                data={card.slug}
                className="mt-4 -ml-4 flex items-baseline rounded-lg py-2 pl-4 lg:hover:bg-background-secondary"
              >
                <span className="font-title text-headings text-text-default">
                  {card.name}
                </span>
                <span className="ml-2 hidden text-bodys md:block">
                  {card.categories
                    ?.map((category) => category.name)
                    .toString()
                    .replaceAll(',', ', ')}
                </span>
              </LinkWrapper>
            ))}
        </div>
      ))}
    </div>
  );
};
